import { createFileRoute } from '@tanstack/react-router';
import { OrgMembersListPage } from '@/pages/organization/org-members/OrgMembersListPage';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/organization/org-members/')({
  component: OrgMembersListPage,
  validateSearch: dataTableSearchSchema({})
});
